import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-pages',
  imports: [RouterModule, HeaderComponent],
  template: `<div>
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>`,
})
export class PagesComponent {
  title: string = 'forgot-password';
}
